import React from 'react';

const BarraEstado = ({ classes, estadisticas }) => {
  return (
    <div className={classes.statusBar}>
      <div className={classes.statusBarGroup}>
        <span className={classes.statusBadge}>
          Hoja Carta (8.5 × 11 in)
        </span>
        <span>
          Páginas aprox: <b>{estadisticas.paginas}</b>
        </span>
        <span>
          Palabras: <b>{estadisticas.palabras}</b>
        </span>
        <span>
          Caracteres: <b>{estadisticas.caracteres}</b>
        </span>
      </div>
      <div className={classes.statusBarGroup}>
        <span style={{ fontSize: 11, color: '#94a3b8' }}>
          Atajo: <b>Ctrl + Enter</b> para insertar salto de página
        </span>
      </div>
    </div>
  );
};

export default React.memo(BarraEstado);
